import React from 'react';

export const BreakdownTable = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="mb-l grid grid-cols-2 gap-[1px] bg-secondary-90">
      {children}
    </div>
  );
};

export const BreakdownTableCell = ({
  title,
  value,
}: {
  title: string;
  value: string | null;
}) => {
  return (
    <div className="bg-secondary-97 p-r last:col-span-2">
      <div className="mb-xs text-center text-xs font-reg">{title}</div>
      <div className="text-center text-s font-med">{value}</div>
    </div>
  );
};
